<template>
    <div class="c-input-items">
        <div class="text-right">
            <b-link @click="onAddClick" class="card-header-action"><i class="fa fa-plus"></i> {{addLabel}}</b-link>
        </div>
        <hr/>
        <table class="table table-stripped">
            <thead>
                <tr>
                    <th v-for="column in dataColumns">
                        {{column.label}}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item, itemIndex in dataValue">
                    <td v-for="column in dataColumns">
                        <InputText
                                v-if="column.field.type === 'text'"
                                :id="column.field.id"
                                :isVisible="column.field.isVisible"
                                :required="column.field.required"
                                :placeholder="column.field.placeholder"
                                :autocomplete="column.field.autocomplete"
                                :labelCols="column.field.labelCols"
                                v-model="dataValue[itemIndex][column.key]"></InputText>
                        <InputNumber
                                v-if="column.field.type === 'number'"
                                :id="column.field.id"
                                :isVisible="column.field.isVisible"
                                :required="column.field.required"
                                :placeholder="column.field.placeholder"
                                :autocomplete="column.field.autocomplete"
                                :labelCols="column.field.labelCols"
                                v-model="dataValue[itemIndex][column.key]"></InputNumber>
                        <InputSelect
                                v-if="column.field.type === 'select'"
                                :id="column.field.id"
                                :options="column.field.options"
                                :isVisible="column.field.isVisible"
                                :required="column.field.required"
                                :placeholder="column.field.placeholder"
                                :autocomplete="column.field.autocomplete"
                                :labelCols="column.field.labelCols"
                                v-model="dataValue[itemIndex][column.key]"></InputSelect>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

  import InputSelect from "./InputSelect"
  import InputText from "./InputText"
  import InputNumber from "./InputNumber"
  export default {
      name: 'InputItems',
      components: {
          InputSelect,
          InputText,
          InputNumber
      },
      props: {
          addLabel: {
              type: String,
              default: 'Élément'
          },
          value: {
              type: Array,
              default: function() {
                  return []
              }
          },
          id: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          },
          columns: {
              type: Array,
              default: function() { return [] }
          },
          fields: {
              type: Array,
              default: function() { return [] }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
          this.dataColumns = this.columns
      },
      data: () => {
          return {
              Core: window.Core,
              dataColumns: [],
              dataValue: [],
          }
      },
      computed: {
      },
      methods: {
          onAddClick() {
              let value = {}
              for(let column in this.dataColumns) {
                  column = this.dataColumns[column]
                  switch(column.field.type) {
                      case 'select':
                          value[column.key] = null
                          break
                      default:
                          value[column.key] = ''
                          break
                  }
              }
              this.dataValue.push(value)
          }
      }
  }
</script>